import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    keyboardKeys: {},
    isSerialConnected: false,
};

export const keyboardSlice = createSlice({
    name: "KeyboardSlice",
    initialState,
    reducers: {
        setKeyboardKeys: (state, action) => {
            state.keyboardKeys = action.payload;
        },
        setIsSerialConnected: (state, action) => {
            state.isSerialConnected = action.payload;
        }
    },
});

export const { setKeyboardKeys, setIsSerialConnected } = keyboardSlice.actions;

export default keyboardSlice.reducer;